import { render } from "./AccessAddRole.vue?vue&type=template&id=dee645f8"
import script from "./AccessAddRole.vue?vue&type=script&lang=js"
export * from "./AccessAddRole.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__